<footer class="app-footer">
      <p class="side-bar-footer-text">@KBR</p>
  <p class="confidentiality-notice">
    This Web site contains business and technical information and data, trade secrets, and know-how that are highly confidential and proprietary to KBR. Any unauthorized publication or disclosure of such information to any person, or any unauthorized use of such information, without the express written consent of KBR is strictly prohibited.
  </p>
</footer>
